import { SEARCH_HISTORY_SEPARATOR } from '../constants';

export const encodeSeparator = (str: string): string => {
  const encodedSeparator = encodeURIComponent(SEARCH_HISTORY_SEPARATOR);
  const regex = new RegExp(`\\${SEARCH_HISTORY_SEPARATOR}+`);
  return str.replace(regex, encodedSeparator);
};
